module.exports = __webpack_public_path__ + "img/american-pale-ale.f90f8e22.jpg";